module.exports = __webpack_public_path__ + "img/platinum.7a5ba8af.jpg";